// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"EmpHistoryAndUtilizeReportTable_tableContainer__2ucNU"};